import React, { Component } from "react";
import PhoneNumberInput from "./../../phone-number-input/PhoneNumberInput";
import constants from '../../.././../../globals/constants';

export const validation = {
    validateOn: ["blur"],
    validationRegex: /(^((\(\d{3}\))|\d{3})[\s\.\-]?\d{3}[\s\.\-]?\d{4}$)|^$/,
    required: true,
    message: {
        default: "Please enter a valid 10 digit phone number"
    }
};

class PhoneNumber extends Component {
    static cleanValue(value) {
        return value.replace(/\D/g, "");
    }
    render() {
        const {
            id,
            name,
            label,
            disabled,
            value,
            hideHelper,
            noTollFree=true
        } = this.props;
        const helper = hideHelper ? '' : "Please review the Communication Consent below about our use of your phone number and email address.";
        const pattern = noTollFree ? constants.patterns.validPhoneWithoutTollFreeAsString() : undefined;
        validation.noTollFreeNumber = noTollFree;
        return (
            <PhoneNumberInput
                id={id || "phone"}
                name={name || "phone"}
                type="text"
                label={label || "Phone Number"}
                validation={validation}
                value={value}
                disabled={disabled}
                helper={helper}
                pattern={pattern}
            />
        );
    }
}

export default PhoneNumber;
